class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      detail: '[js-header-menu-expand]',
      summary: '[js-header-summary]'
    }
  }

  connectedCallback() {
    this.details = document.querySelectorAll(this._selectors.detail);
    this.summaries = document.querySelectorAll(this._selectors.summary);

    this.details.forEach(detail => {
      detail.addEventListener('mouseenter', this._expandMenu);
      detail.addEventListener('mouseleave', this._hideMenu);
    })
  }

  _expandMenu = (e) => {
    var summaryClick = e.target.querySelector(this._selectors.summary)
    summaryClick.click();
  }

  _hideMenu = (e) => {
    var summaryClick = e.target.querySelector(this._selectors.summary)
    summaryClick.click();
  }


}

if (!customElements.get('s-nav')) {
  customElements.define("s-nav", MegaMenu);
}